import React, { DragEvent } from 'react';

import { Frame } from '../../../lib/utils/transform-image';
import { formatPicture } from '../../../core/services/image.service';
import { Add } from '../../../components/icons';
import { selectFiles } from '../../../core/services/file.service';

import styles from './cover-placeholder.module.scss';
type CoverPlaceholderProps = {
  onUpload: (frame: Frame) => void;
};

export const CoverPlaceholder: React.FC<CoverPlaceholderProps> = ({ onUpload }) => {
  const handleUpload = async (file: File) => {
    let frame;

    if (file.type === 'image/gif') {
      frame = {
        data: file,
        size: file.size,
        type: file.type,
      };
    } else {
      const options = { width: 640, height: 380 };
      frame = await formatPicture(file, options);
    }

    onUpload(frame);
  };

  const handleDragEnter = (e: DragEvent<HTMLDivElement>) => {
    e.preventDefault();
  };

  const handleDragLeave = (e: DragEvent<HTMLDivElement>) => {
    e.preventDefault();
  };

  const handleDragOver = (e: DragEvent<HTMLDivElement>) => {
    e.preventDefault();
  };

  const handleDrop = async (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    e.stopPropagation();

    const files = Array.from(e.dataTransfer.items).map((item) => item);

    if (files.filter((el) => el.kind === 'string').length > 0) {
      return;
    }

    const file = Array.from(e.dataTransfer.items)[0].getAsFile();

    if (file) {
      handleUpload(file);
    }
  };

  const handleClick = async (e: React.MouseEvent) => {
    e.stopPropagation();
    const files = await selectFiles();

    if (!files) {
      return;
    }

    const file = Array.from(files)[0];

    if (file) {
      handleUpload(file);
    }
  };

  return (
    <div
      className={styles['placeholder']}
      onDragEnter={handleDragEnter}
      onDragLeave={handleDragLeave}
      onDragOver={handleDragOver}
      onDrop={handleDrop}
      onClick={handleClick}
    >
      <Add />
      Add photo
    </div>
  );
};
